import { render, staticRenderFns } from "./cultura.vue?vue&type=template&id=fd16eaa2&scoped=true"
import script from "./cultura.vue?vue&type=script&lang=js"
export * from "./cultura.vue?vue&type=script&lang=js"
import style0 from "./cultura.vue?vue&type=style&index=0&id=fd16eaa2&prod&scoped=true&lang=css"
import style1 from "./cultura.vue?vue&type=style&index=1&id=fd16eaa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd16eaa2",
  null
  
)

export default component.exports